import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'dynamic-data-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class DynamicDataFormDialogComponent implements OnInit
{
  public formGroup: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    text: new FormControl('', Validators.required)
  });
  action: string;
  dialogTitle;
  organizationType;

    constructor(
        public dialogRef: MatDialogRef<DynamicDataFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'dynamicData.edit';
            this.organizationType = data.type;
        }
        else
        {
            this.dialogTitle = 'dynamicData.new';
        }
    }

    ngOnInit()
    {
      if (this.action === 'edit') {
        this.formGroup.patchValue(this.organizationType);
      }
    }
}
